export enum MEDIA_TYPE {
    TITLE = 'title',
    MOVIE = 'movie',
    SERIES = 'series',
    PERSON = 'person',
    EPISODE = 'episode',
    SEASON = 'season',
    NEWS = 'news_article',
}
